import type { IncludedServices } from '@/scopes/search/search/infrastructure/api/types'
import type { IconGlyph } from '@sunwebgroup/ui-components'
import { AccommodationService } from '@/scopes/search/search/pages/SearchPage/components/Results/Result'

export function transformIncludedServices(includedServices?: IncludedServices): AccommodationService[] {
  const excludedServices = ['accommodation', 'flight', 'bus']

  if (!includedServices) {
    return []
  }

  // Filter out excluded services and create a new array of accommodation services
  const services: AccommodationService[] = Object.entries(includedServices)
    .filter(([key]) => !excludedServices.includes(key))
    .map(([key, value]) => ({
      key,
      icon: getIconForService(key),
      text: value,
    }))

  return services
}

function getIconForService(service: string): IconGlyph | undefined {
  const serviceIconMap: Record<string, IconGlyph> = {
    carrental: 'IconCarFront',
    skimaterial: 'IconSkiMaterial',
    skipass: 'IconSkiPass',
    transfer: 'IconBusFront',
  }

  return serviceIconMap[service]
}
